import { Dayjs } from "dayjs"
import {
  BillRequestStatus,
  BillRequestTypeCode,
  IBillRequest,
} from "./billRequest.types"

export class BillRequest implements IBillRequest {
  id: number
  billId: number
  billPeriodFromDttm: Dayjs
  billPeriodToDttm: Dayjs
  statusCode: BillRequestStatus
  taskCreatedDttm: Dayjs
  taskFinishDttm: Dayjs
  taskStartDttm: Dayjs
  taskUserTblUsername: string
  typeCode: BillRequestTypeCode
  isTest: boolean
  serverMessage?: string
  coreBillId?: number

  constructor(
    id: number,
    billId: number,
    billPeriodFromDttm: Dayjs,
    billPeriodToDttm: Dayjs,
    statusCode: BillRequestStatus,
    taskCreatedDttm: Dayjs,
    taskFinishDttm: Dayjs,
    taskStartDttm: Dayjs,
    taskUserTblUsername: string,
    typeCode: BillRequestTypeCode,
    isTest: boolean,
    serverMessage?: string,
    // Appended last on purpose: the constructor is positional, so inserting
    // earlier would silently re-bind every existing construction site.
    coreBillId?: number,
  ) {
    this.id = id
    this.billId = billId
    this.billPeriodFromDttm = billPeriodFromDttm
    this.billPeriodToDttm = billPeriodToDttm
    this.statusCode = statusCode
    this.taskCreatedDttm = taskCreatedDttm
    this.taskFinishDttm = taskFinishDttm
    this.taskStartDttm = taskStartDttm
    this.taskUserTblUsername = taskUserTblUsername
    this.typeCode = typeCode
    this.isTest = isTest
    this.serverMessage = serverMessage
    this.coreBillId = coreBillId
  }

  get isFailed(): boolean {
    return !this.isTest && this.statusCode === "Failed"
  }
}
